import React, {Component} from "react";
import {setUserActive, setUserAuth, setUserData, setUserDebts, setUserToken} from "../../store/user/actions";
import {setTapBarData} from "../../store/tapBar/actions";
import {setBankTransferType, setCardTransferData} from "../../store/transfer/actions";
import {connect} from "react-redux";
import {withRouter} from "@happysanta/router";
import {Div} from "@vkontakte/vkui";
import axios from "../../axios/axios";
import SkillItem from "./JobItem";
import {SERVER_CONFIG} from "../../config";
import JobItem from "./JobItem";


class JobList extends Component {

    state = {
        jobList: []
    }



    render() {
        const jobList = this.state.jobList
        return (
            jobList.map((item, key) => {
                return (<JobItem item={item} key={key}/>)
            })
        )
    }

    componentDidMount() {
      axios.get('job')
            .then(res => res.data)
            .then(res => this.setState({jobList: res}))

    }
}

const mapStateToProps = (state) => {
        return {
            user: state.user,
            tapBar: state.tapBar,
            transfer: state.transfer
        };
    }
;

const mapDispatchToProps =
    {
        setUserData,
        setUserAuth,
        setUserToken,
        setUserActive,
        setUserDebts,
        setTapBarData,
        setCardTransferData,
        setBankTransferType
    }
;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(JobList));